import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { isAxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const fetchUsers = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await authApiClient.get('/users', {
    params: {
      page: params?.page ?? 0,
      page_size: params?.size ?? 10,
    },
  });
  return data;
};

export const useGetUsersHandler = ({ searchQuery = {} } = {}) => {
  const dispatch = useDispatch();
  const query = useQuery({
    queryKey: ['auth-users', { ...searchQuery }],
    queryFn: fetchUsers,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!query.isError) return;

    if (isAxiosError(query.error)) {
      dispatch(
        showSnackbar({
          message: query.error.response?.data?.errors?.message || query.error.message,
          severity: 'error',
        }),
      );
      return;
    }

    dispatch(
      showSnackbar({
        message: 'Failed to fetch users',
        severity: 'error',
      }),
    );
  }, [dispatch, query.error, query.isError]);

  return {
    users: query.data?.content ?? [],
    totalElements: query.data?.total_elements ?? 0,
    pageNumber: query.data?.page_number ?? 0,
    totalPages: query.data?.total_pages ?? 1,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
